// MOCKUP_REGISTRY_START
const MOCKUP_REGISTRY = {
  "aepr-explorer": () => import("./aepr-explorer")
};
// MOCKUP_REGISTRY_END

export default MOCKUP_REGISTRY;
